import { useAuth } from "./context/AuthContext";
import { MasterDataProvider } from "./context/MasterDataContext";
import { TemaDisplayShell } from "./components/layout/TemaDisplayShell";
import { TemaAppRoutes } from "./routes/TemaAppRoutes";
import { AuthEntryPage } from "./pages/AuthEntryPage";

function LaunchLoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-page-bg px-4">
      <div className="text-center">
        <p className="text-sm font-medium text-primary">ITEMA</p>
        <p className="mt-2 text-lg font-semibold text-text-primary">
          Signing in…
        </p>
      </div>
    </div>
  );
}

function App() {
  const { isAuthenticated, isLaunching, accessibility } = useAuth();

  return (
    <TemaDisplayShell accessibility={accessibility}>
      {isLaunching ? (
        <LaunchLoadingScreen />
      ) : !isAuthenticated ? (
        <AuthEntryPage />
      ) : (
        <MasterDataProvider>
          <TemaAppRoutes />
        </MasterDataProvider>
      )}
    </TemaDisplayShell>
  );
}

export default App;
